import { Link, useLocation } from "react-router-dom";
import { useUnreadChatsCount } from "@/hooks/useUnreadChats";
import { useTranslations } from "@/contexts/I18nContext";

const sidebarItems = [
  { href: "/dashboard", labelKey: "sidebar.home", icon: "\u{1F3E0}" },
  { href: "/posts", labelKey: "sidebar.posts", icon: "\u{1F4CB}" },
  { href: "/chats", labelKey: "sidebar.chats", icon: "\u{1F4AC}" },
  { href: "/chores", labelKey: "sidebar.chores", icon: "✅" },
  { href: "/choreboard", labelKey: "sidebar.choreboard", icon: "\u{1F3AF}" },
  { href: "/events", labelKey: "sidebar.events", icon: "\u{1F4C5}" },
  { href: "/shopping", labelKey: "sidebar.shopping", icon: "\u{1F6D2}" },
  { href: "/grocery", labelKey: "sidebar.groceries", icon: "\u{1F955}" },
  { href: "/meals", labelKey: "sidebar.meals", icon: "\u{1F372}" },
  { href: "/cookbook", labelKey: "sidebar.cookbook", icon: "\u{1F4D6}" },
  { href: "/weekend", labelKey: "sidebar.weekend", icon: "\u{1F3D5}️" },
  { href: "/responsibilities", labelKey: "sidebar.responsibilities", icon: "\u{1F465}" },
  { href: "/members", labelKey: "sidebar.members", icon: "\u{1F46A}" },
  { href: "/notifications", labelKey: "sidebar.notifications", icon: "\u{1F514}" },
  { href: "/account", labelKey: "sidebar.account", icon: "\u{1F464}" },
];

export function Sidebar() {
  const { pathname } = useLocation();
  const unreadChatsCount = useUnreadChatsCount();
  const t = useTranslations();

  return (
    <aside className="hidden sm:flex flex-col w-56 border-r border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 h-screen sticky top-0">
      <div className="p-4">
        <h1
          className="text-xl font-bold"
          style={{ color: "var(--accent-color)" }}
        >
          Zoey
        </h1>
      </div>
      <nav className="flex-1 px-2 space-y-1">
        {sidebarItems.map((item) => {
          const active = pathname.startsWith(item.href);
          const showBadge = item.href === "/chats" && unreadChatsCount > 0;
          return (
            <Link
              key={item.href}
              to={item.href}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                active
                  ? "bg-[color:var(--accent-color)]/10 text-[color:var(--accent-color)] font-semibold"
                  : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-white/5"
              }`}
            >
              <span>{item.icon}</span>
              <span className="flex-1">{t(item.labelKey)}</span>
              {showBadge && (
                <span
                  className="min-w-[20px] h-5 px-1.5 rounded-full text-white text-xs font-bold flex items-center justify-center"
                  style={{ backgroundColor: "var(--accent-color, #00C7BE)" }}
                >
                  {unreadChatsCount}
                </span>
              )}
            </Link>
          );
        })}
      </nav>
      <div className="px-3 py-4 border-t border-gray-200 dark:border-gray-800">
        <Link
          to="/account"
          className="flex items-center gap-2 px-3 py-2 rounded-lg text-xs text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-white/5 transition-colors"
        >
          <span>{"\u{1F4E3}"}</span>
          <span>{t("sidebar.sendFeedback")}</span>
        </Link>
      </div>
    </aside>
  );
}
